module.exports = __webpack_public_path__ + "img/Alert.beca0267b.svg";